import React from 'react'
import { Box, Typography } from '@mui/material'
import { Avatar } from 'packages/eid-ui'

const nameStyle = {
    fontSize: '14px',
    color: '#5d6870',
    padding: '10px 0px'
}

const Person = ({ imgSrc, name }) => (
    <Box display="flex" alignItems="center" overflow='hidden' >
        <Box component="span" padding="10px 10px" >
            <Avatar src={imgSrc} /> 
        </Box>
        <Typography style={nameStyle}>{name}</Typography>
    </Box>
)

export default Person
